<template>
  <div>
    <!-- {{ this.getAccess }} -->
    <SkeletonLoader v-if="load == false"></SkeletonLoader>
    <!-- content page -->
    <div v-else class="space-view">
      <div class="space-m">
        <div class="space-img-logo">
          <img class="logo" alt src="../../assets/img/logo_x2.png" />
        </div>
        <div class="ctn-m">
          <!-- menu de navegacion lateral -->
          <nav-dash :elem="this.nav"></nav-dash>
        </div>
      </div>
      <div class="space-c">
        <comp-snackbar
          :visible="this.snackbarFlat"
          :action="this.snackbarStatus"
          :text="this.snackbarText"
        ></comp-snackbar>
        <v-row v-if="querySpaceData != null" class="custom" no-gutters>
          <v-col md="5">
            <div class="filter-d">
              <div class="filter-search">
                <v-text-field
                  v-model="searchFileAll"
                  prepend-inner-icon="mdi-magnify"
                  solo
                  label="Buscar en todos los archivos"
                  hide-details
                ></v-text-field>
                <v-btn @click="ActionSearch" color="secondary"> Buscar</v-btn>
              </div>
              <!-- <div class="filter-tag">
                <v-select :items="items" label="Referencia"></v-select>
              </div> -->
              <!-- <div class="filter-search">
                <v-text-field
                  v-model="searchSuper"
                  prepend-inner-icon="mdi-magnify"
                  solo
                  label="Buscar archivos y carpetas"
                  hide-details
                ></v-text-field>
              </div> -->
            </div>
          </v-col>
          <v-col md="7">
            <header-dash></header-dash>
          </v-col>
          <v-col md="12">
            <v-row>
              <v-col md="6">
                <!-- <div class="breadcrum">
                  <v-btn
                    plain
                    :to="{
                      name: 'SpaceView'
                    }"
                    >Espacios</v-btn
                  >
                  >
                  <v-btn
                    plain
                    :to="{
                      name: 'SpaceItemView',
                      params: { id: querySpaceData._id }
                    }"
                    >{{ querySpaceData.name }}</v-btn
                  >
                </div> -->
              </v-col>
              <v-col md="6">
                <div
                  v-if="getAccess.leave == 'admin' || getAccess.leave == 'edit'"
                  class="created-c"
                >
                  <v-menu class="" content-class="menu-created" bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on">
                        <v-icon>mdi-plus</v-icon>
                        <span class="created-t">Nuevo</span>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-btn class="btn-me" @click="folderNew = true">
                          <v-icon class="folder">mdi-folder</v-icon>
                          <span>Nueva carpeta</span>
                        </v-btn>
                      </v-list-item>
                      <v-list-item>
                        <v-btn class="btn-me" @click="fileNew = true">
                          <v-icon class="">mdi-file-upload-outline</v-icon>
                          <span>Subir archivo</span>
                        </v-btn>
                      </v-list-item>
                      <v-list-item>
                        <v-btn class="btn-me" @click="fileMassiveNew = true">
                          <v-icon class="">mdi-file-upload-outline</v-icon>
                          <span>Subir archivos masivos</span>
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col md="9">
            <div v-if="searchDeep != null" class="noty-space search-space">
              <v-row>
                <v-col cols="8">
                  <div class="space-h2">
                    <h2>Resultado de la Busqueda</h2>
                    <p></p>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="noty-ctn-btn">
                    <v-btn class="clear-btn" @click="clearSearch"
                      >Borrar busqueda</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
              <list-search :resultSearch="resultSearch"></list-search>
            </div>
            <div class="search-only">
              <div class="space-h2">
                <h2>{{ querySpaceData.name }}</h2>

                <div
                  v-if="querySpaceData.path.length > 0"
                  class="breadcrums-only"
                >
                  <span v-for="ruta in querySpaceData.path" :key="ruta._id">
                    <router-link
                      plain
                      :to="{
                        name: 'SpaceItemView',
                        params: { id: ruta._id }
                      }"
                      >{{ ruta.name }} >
                    </router-link>
                  </span>
                </div>
                <div v-else class="breadcrums-only">
                  <span>
                    <router-link
                      plain
                      :to="{
                        name: 'SpaceView'
                      }"
                      >espacios ></router-link
                    >
                  </span>
                </div>
              </div>
              <div class="search-text-only">
                <v-text-field
                  v-model="searchSuper"
                  prepend-inner-icon="mdi-magnify"
                  solo
                  label="Buscar aqui..."
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <div class="data-tab-space">
              <v-data-table
                :headers="headerSpace"
                :items="listData"
                :server-items-length="totalNumberOfItems"
                :options.sync="pagination"
                :sort-by="['createdAt']"
                :sort-desc="[true]"
                multi-sort
                loading-text="Cargando información …."
                :search="searchSuper"
              >
                <template v-slot:[`item.name`]="{ item }">
                  <div class="tab-info-space">
                    <span class="name-space"> {{ item.name }}</span>
                  </div>
                </template>
                <template v-slot:[`item.icono`]="{ item }">
                  <!-- icono render  -->
                  <icon-render :item="item"></icon-render>
                </template>
                <template v-slot:[`item.updateAt`]="{ item }">
                  <div class="tab-info-space">
                    <span> {{ item.updateAt | formatDate }}</span>
                  </div>
                </template>
                <template v-slot:[`item.size`]="{ item }">
                  <div class="tab-info-space">
                    <span> {{ item.size }}</span>
                  </div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <div class="tab-action-space">
                    <v-btn
                      class="btn-open"
                      v-if="item.icono == 'file' && item.block != true"
                      @click="createdUrl(item._id, item.name, item.ext)"
                      target="_blank"
                    >
                      <!-- <v-icon>mdi-download</v-icon> -->
                      <span>Descargar</span>
                    </v-btn>
                    <v-btn
                      v-else-if="
                        getAccess.leave == 'admin' ||
                        (getAccess.leave == 'edit' && item.block != true) ||
                        (getAccess.leave == 'read' && item.block != true)
                      "
                      class="btn-open"
                      :to="{
                        name: 'FolderView',
                        params: { id: item._id }
                      }"
                    >
                      <span>Abrir</span>
                    </v-btn>
                    <v-btn v-else class="btn-open" disabled>
                      <span>Abrir</span>
                    </v-btn>

                    <v-menu class="" content-class="menu-created" bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon class="btn-m-tab" v-bind="attrs" v-on="on">
                          <v-icon>mdi-dots-vertical-circle</v-icon>
                          <span class="">{{ item.actions }}</span>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-if="
                            getAccess.leave == 'admin' ||
                            (getAccess.leave == 'edit' && item.block != true) ||
                            (getAccess.leave == 'read' && item.block != true)
                          "
                        >
                          <v-btn
                            class="btn-me"
                            v-if="item.icono == 'file' && item.block != true"
                            @click="createdUrl(item._id, item.name, item.ext)"
                            target="_blank"
                          >
                            <v-icon>mdi-download</v-icon>
                            <span>Descargar</span>
                          </v-btn>
                          <v-btn
                            v-else
                            class="btn-me"
                            :to="{
                              name: 'FolderView',
                              params: { id: item._id }
                            }"
                          >
                            <v-icon>mdi-folder-open</v-icon>
                            <span>Abrir</span>
                          </v-btn>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            getAccess.leave == 'admin' ||
                            (getAccess.leave == 'edit' && item.block != true)
                          "
                        >
                          <v-btn class="btn-me" @click="editItem(item)">
                            <v-icon>mdi-folder-edit</v-icon>
                            <span>Editar</span>
                          </v-btn>
                        </v-list-item>
                        <!-- <v-list-item
                          v-if="item.icono == 'file' && item.block != true"
                        >
                          <v-btn
                            class="btn-me"
                            @click="createdUrl(item._id, item.name, item.ext)"
                          >
                            <v-icon>mdi-download</v-icon>
                            <span>Descargar</span>
                          </v-btn>
                        </v-list-item> -->
                        <v-list-item v-if="getAccess.leave == 'admin'">
                          <v-btn class="btn-me" @click="invitedUser(item)">
                            <v-icon>mdi-account-plus</v-icon>
                            <span>Compartir</span>
                          </v-btn>
                        </v-list-item>

                        <v-list-item v-if="getAccess.leave == 'admin'">
                          <v-btn class="btn-me" @click="lockItem(item)">
                            <v-icon>mdi-lock</v-icon>
                            <span>Bloquear</span>
                          </v-btn>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            getAccess.leave == 'admin' ||
                            (getAccess.leave == 'edit' && item.block != true)
                          "
                        >
                          <v-btn class="btn-me" @click="deleteItem(item)">
                            <v-icon>mdi-delete-outline</v-icon>
                            <span>Papelera</span>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn
                      @click="infoItem(item)"
                      icon
                      class="btn-m-tab hover-act"
                    >
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="getAccess.leave == 'admin'"
                      @click="invitedUser(item)"
                      icon
                      class="btn-m-tab hover-act"
                    >
                      <v-icon>mdi-account-plus</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </div>
            <!-- file new -->
            <new-file
              :space="querySpaceData"
              :parent="querySpaceData"
              :visible="fileNew"
              @close="fileNew = false"
            ></new-file>
            <newMassiveFile
              :space="querySpaceData"
              :parent="querySpaceData"
              :visible="fileMassiveNew"
              @close="fileMassiveNew = false"
            />
            <edit-file
              :space="querySpaceData"
              :item="itemObjct"
              :visible="editFileFlag"
              @close="editFileFlag = false"
            >
            </edit-file>
            <!-- new folder -->
            <new-folder
              :space="querySpaceData"
              :parent="querySpaceData"
              :visible="folderNew"
              @close="folderNew = false"
            ></new-folder>
            <shared-folder
              :space="querySpaceData"
              :item="itemObjct"
              :visible="sharedFlag"
              @close="sharedFlag = false"
            ></shared-folder>
            <edit-folder
              :space="querySpaceData"
              :item="itemObjct"
              :visible="EditFlag"
              @close="EditFlag = false"
            ></edit-folder>
            <lock-folder
              :space="querySpaceData"
              :item="itemObjct"
              :visible="lockFlag"
              @close="lockFlag = false"
            ></lock-folder>
            <delete-folder
              :space="querySpaceData"
              :item="itemObjct"
              :visible="deleteFlag"
              @close="deleteFlag = false"
            ></delete-folder>
          </v-col>
          <v-col md="3">
            <detail-folder
              :item="itemObjct"
              :typeFile="'espacio'"
            ></detail-folder>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
// other components
import SnackbarComp from "@/components/Snackbar.vue";
import SkeletonLoader from "@/components/SkeletonLoader.vue";
import HeaderDash from "@/components/HeaderDash.vue";
import IconRender from "@/components/IconRender.vue";
import Nav from "@/components/NavDash.vue";

// crud
import newFile from "@/components/file/FileNew.vue";
import newMassiveFile from "@/components/file/FileMassiveNew.vue";
import EditFile from "@/components/file/FileEdit.vue";
import newFolder from "@/components/folder/FolderNew.vue";
import EditFolder from "@/components/folder/FolderEdit.vue";
import DeleteFolder from "@/components/folder/FolderDelete.vue";
import DetailFolder from "@/components/folder/FolderDetail.vue";
import LockFolder from "@/components/folder/FolderLock.vue";
import SharedFolder from "@/components/folder/FolderShared.vue";
import ListSearch from "@/components/folder/SearchFile.vue";

// libraries
import axios from "axios";
import moment from "moment";
import download from "downloadjs";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "spaceItemView",
  components: {
    SkeletonLoader,
    //"space-table": SpaceTable,
    "detail-folder": DetailFolder,
    "header-dash": HeaderDash,
    "nav-dash": Nav,
    "icon-render": IconRender,
    "new-file": newFile,
    "edit-file": EditFile,
    "new-folder": newFolder,
    "edit-folder": EditFolder,
    "delete-folder": DeleteFolder,
    "lock-folder": LockFolder,
    "comp-snackbar": SnackbarComp,
    "shared-folder": SharedFolder,
    "list-search": ListSearch,
    newMassiveFile
  },

  data() {
    return {
      access: null,
      nav: "space",
      url: null,
      querySpaceData: null,
      load: false,
      fileNew: false,
      fileMassiveNew: false,
      editFileFlag: false,
      folderNew: false,
      EditFlag: false,
      sharedFlag: false,
      lockFlag: false,
      deleteFlag: false,
      searchSuper: "",
      searchFileAll: null,
      snackbarFlat: false,
      snackbarStatus: null,
      snackbarText: null,
      listData: [],
      resultSearch: null,
      itemObjct: {},
      page: 0,
      totalNumberOfItems: 0,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10
      },
      headerSpace: [
        { text: "", value: "icono" },
        { text: "Nombre", value: "name" },
        { text: "Ultima Actualización", value: "updateAt" },
        { text: "Tamaño", value: "size" },
        { text: "Acciones", value: "actions", sortable: false }
      ]
    };
  },
  async created() {
    this.loadBar();
    this.querySpaceData = await this.querySpace(this.$route.params.id);
    this.access = await this.queryAccessDeep(this.$route.params.id);
    //console.log('querySpaceData', this.querySpaceData);
    if (
      this.querySpaceData.state == false ||
      this.querySpaceData.block == true
    ) {
      if (this.querySpaceData.user._id == this.isLogin._id) {
        return;
      } else {
        this.$router.push({ name: "Route404" });
      }
    }
    await this.getListFile();
    // root data dom
    this.$root.$on("reload", async () => {
      await this.getListFile();
    });
    this.$root.$on("snackbar", async (el) => {
      if (el != null) {
        await this.getSnackbar(el);
      }
    });
  },
  watch: {
    async $route() {
      this.loadBar();
      this.querySpaceData = await this.querySpace(this.$route.params.id);
      this.access = await this.queryAccessDeep(this.$route.params.id);
      //console.log('querySpaceData', this.querySpaceData);
      if (
        this.querySpaceData.state == false ||
        this.querySpaceData.block == true
      ) {
        if (this.querySpaceData.user._id == this.isLogin._id) {
          return;
        } else {
          this.$router.push({ name: "Route404" });
        }
      }
      await this.getListFile();
      // root data dom
      await this.routerReload();
      this.$root.$on("reload", async () => {
        await this.getListFile();
      });
      this.$root.$on("snackbar", async (el) => {
        if (el != null) {
          await this.getSnackbar(el);
        }
      });
    },

    snackbar: {
      handler() {
        this.$root.$on("snackbar", async (el) => {
          await this.getSnackbar(el);
        });
      },
      deep: true
    },

    searchSuper: {
      handler() {
        this.getListFile().then((el) => {
          this.listData = el.docs;
        });
      },
      deep: true
    },
    pagination: {
      handler() {
        this.getListFile().then((el) => {
          this.listData = el.docs;
        });
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      "querySpace",
      "queryUser",
      "queryAccessDeep",
      "queryDownload"
    ]),
    async loadBar() {
      setTimeout(() => {
        this.load = true;
      }, 1000);
      await this.queryUser();
    },
    async clearSearch() {
      this.searchFileAll = null;
      this.resultSearch = null;
    },
    async ActionSearch() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          axios
            .get(
              `space/search?page=${this.pagination.page}&search=${this.searchFileAll}`,
              {
                headers: headerToken
              }
            )
            .then((res) => {
              //console.log('space', res.data);
              this.resultSearch = res.data;
              //this.totalNumberOfItems = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getSnackbar(n) {
      //console.log('--', n)
      this.snackbarFlat = n.visible;
      this.snackbarStatus = n.status;
      this.snackbarText = n.text;
    },
    async createdUrl(id, name, ext) {
      let urlresp = await this.queryDownload(id);

      download(urlresp, `${name}${ext}`);
    },
    async getListFile() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          axios
            .get(
              `space/list/folder?page=${this.pagination.page}&id=${this.$route.params.id}&search=${this.searchSuper}`,
              {
                headers: headerToken
              }
            )
            .then((res) => {
              //console.log("spaceItemView", res.data);
              this.listData = res.data.docs;
              this.totalNumberOfItems = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    editItem(param) {
      this.itemObjct = Object.assign({}, param);
      if (param.icono != "file") {
        this.EditFlag = true;
      } else {
        this.editFileFlag = true;
      }
    },
    infoItem(param) {
      //console.log("info", param);
      this.itemObjct = Object.assign({}, param);
      //this.EditFlag = true;
    },
    lockItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.lockFlag = true;
    },
    deleteItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.deleteFlag = true;
    },
    invitedUser(param) {
      this.itemObjct = Object.assign({}, param);
      this.sharedFlag = true;
    },
    async routerReload() {
      this.loadBar();
      this.querySpaceData = await this.querySpace(this.$route.params.id);
      this.$root.$on("reload", async () => {
        await this.getListFile();
      });
    }
  },

  computed: {
    ...mapGetters(["getUser", "isLogin"]),
    searchDeep() {
      return this.resultSearch;
    },
    getAccess() {
      let ob = null;
      if (this.access != null) {
        ob = this.access[0];
        return ob;
      } else {
        return {};
      }
    }
  },
  filters: {
    formatDate: (value) => {
      if (value) {
        return moment(value).locale("es").format("LLL");
      }
      return "-";
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/base.scss";
</style>
